import { Component, Injector, NgZone } from '@angular/core';
import { EnvironmentDataService } from '../angular-common/environment-data.service';
import { LocaleDataService } from '../angular-common/locale-data.service';
import { isDesktopApp } from '../../../../submodules/engine-common/environment-util';
import { IconsService } from './icons.service';

@Component({ template: '' })
export class BaseAppComponent {

  // Se vale true viene visualizzata l'app, altrimenti un loading-screen
  public showApp = false;

  constructor(protected _injector: Injector) {
    this._injector.get(IconsService).registerIcons();
    this._injector.get(LocaleDataService).init();

    this._showApp();
  }

  private _showApp = () => {
    if (isDesktopApp()) {
      this._injector.get(EnvironmentDataService).ipcRenderer.on('ON_MAIN_INITIALIZED', (event) => {
        console.log('ON_MAIN_INITIALIZED :');
        this._injector.get(NgZone).run(() => this.showApp = true);
      });
      this._injector.get(EnvironmentDataService).ipcRenderer.send('RENDERER_INITIALIZED');
    }
    else
      this.showApp = true;
  }
}
